import * as React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import './CourseDetail.css'
import CourseDetailState from './CourseDetailState'
import { CourseConfig, TeacherConfig, TeacherDayMapping } from '../../../configs/stream-entities'
import TeacherList from '../../teacher/teacher-list/TeacherList'
import * as Sentry from "@sentry/browser";
import {Button, TextField} from "@material-ui/core";

class CourseDetailProps {
    public courseId: string
}

interface CourseDayDetailProps {
    index: number;
    onDayChecked: any;
    onTeacherSelected: any;
    checkDayOfTheWeek: any;
    teacherDayOfTheWeek: any;
    weekDayName: string;

    themeDayOfWeek: any;
    onThemeChanged: any;

    durationDayOfWeek: any;
    onDurationChanged: any;

    titleDayOfWeek: any;
    onTitleChanged: any;

    onCoverImageUrlChanged: any;
    coverImageUrlDayOfWeek: any;

    onCustomDescriptionChanged: any;
    customDescriptionDayOfWeek: any;
}

const CourseDayDetail: React.FC<CourseDayDetailProps> = (props: CourseDayDetailProps) => {
    return (
        <div className="course-day-detail-component">
            <div className='day-of-the-week-label'>
                <input type="checkbox" name="dayOfTheWeek[]" value={props.index} onChange={props.onDayChecked} checked={props.checkDayOfTheWeek(props.index)} />
                <span>{props.weekDayName}</span>
            </div>
            {
                props.checkDayOfTheWeek(props.index) &&
                <TeacherList isMultiple={false} defaultValue={props.teacherDayOfTheWeek(props.index)} onItemSelected={props.onTeacherSelected(props.index)} />
            }
            {
                props.checkDayOfTheWeek(props.index) &&
                <input className="title-field" type='string' placeholder='Title' onChange={props.onTitleChanged(props.index)} value={props.titleDayOfWeek(props.index)} />
            }
            {
                props.checkDayOfTheWeek(props.index) &&
                <input className="theme-field" type='string' placeholder='Theme' onChange={props.onThemeChanged(props.index)} value={props.themeDayOfWeek(props.index)} />
            }
            {
                props.checkDayOfTheWeek(props.index) &&
                <input className="duration-field" type='number' placeholder='Duration (mins)' onChange={props.onDurationChanged(props.index)} value={props.durationDayOfWeek(props.index)} />
            }
            {
                props.checkDayOfTheWeek(props.index) &&
                <input className="custom-image-url-field" type='string' placeholder='Cover Image Url' onChange={props.onCoverImageUrlChanged(props.index)} value={props.coverImageUrlDayOfWeek(props.index)} />
            }
            {
                props.checkDayOfTheWeek(props.index) &&
                <textarea className="custom-description-field"  placeholder='Custom Course Description' onChange={props.onCustomDescriptionChanged(props.index)} value={props.customDescriptionDayOfWeek(props.index)} />
            }
        </div>
    )
};

class CourseDetail extends React.Component<CourseDetailProps, CourseDetailState> {

    private formRef: React.RefObject<HTMLFormElement>;
    private inputRef: React.RefObject<HTMLInputElement>;
    private nameRef: React.RefObject<HTMLInputElement>;

    private dayIndexMapping = [
        {day: 'Monday', index: 2},
        {day: 'Tuesday', index: 3},
        {day: 'Wednesday', index: 4},
        {day: 'Thursday', index: 5},
        {day: 'Friday', index: 6},
        {day: 'Saturday', index: 7},
        {day: 'Sunday', index: 1},
    ];

    constructor(props: CourseDetailProps) {
        super(props);
        const newState = new CourseDetailState();
        newState.selectedId = props.courseId;
        this.state = newState;
        this.formRef = React.createRef<HTMLFormElement>();
        this.inputRef = React.createRef<HTMLInputElement>();
        this.nameRef = React.createRef<HTMLInputElement>();
        this.onCourseNameChange = this.onCourseNameChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onDayChecked = this.onDayChecked.bind(this);
        this.checkDayOfTheWeek = this.checkDayOfTheWeek.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.checkTime = this.checkTime.bind(this);
        this.onTeacherSelected = this.onTeacherSelected.bind(this);
        this.setDuration = this.setDuration.bind(this);
        this.teacherDayOfTheWeek = this.teacherDayOfTheWeek.bind(this);

        this.onThemeChanged = this.onThemeChanged.bind(this);
        this.themeDayOfWeek = this.themeDayOfWeek.bind(this);

        this.onTitleChanged = this.onTitleChanged.bind(this);
        this.titleDayOfWeek = this.titleDayOfWeek.bind(this);

        this.onDurationChanged = this.onDurationChanged.bind(this);
        this.durationDayOfWeek = this.durationDayOfWeek.bind(this);

        this.onCoverImageUrlChanged = this.onCoverImageUrlChanged.bind(this);
        this.coverImageUrlDayOfWeek = this.coverImageUrlDayOfWeek.bind(this);

        this.customDescriptionDayOfWeek = this.customDescriptionDayOfWeek.bind(this);
        this.onCustomDescriptionChanged = this.onCustomDescriptionChanged.bind(this);
    }

    public componentWillUpdate(nextProps: CourseDetailProps) {
        if (this.props.courseId !== nextProps.courseId) {
            firebase.firestore().collection('config').doc("CoursesConfig")
                .collection('courses').doc(nextProps.courseId)
                .get().then(snapshot => {
                    const newData = snapshot.data();
                    if(newData) {
                        const newState = new CourseDetailState();
                        Object.assign(newState, snapshot.data()!);
                        newState.selectedId = snapshot.id;
                        newState.courseName = this.getClassIdentifier(snapshot.data()!.titleLabel).replace(/ /g, '_');
                        this.setState(newState);
                    }
            })
        }
    }

    public render() {
        return (<div className="CourseDetail">

            <Button className='reset-button' onClick={this.resetForm} color='default' variant="contained">
                Reset
            </Button>

            <form ref={this.formRef} onSubmit={this.onSubmit}>

                {
                    !!this.state.selectedId && <div className='id-info'>Timeslot Id: {this.state.selectedId}</div>
                }

                <label htmlFor="courseNameLabel">Course name</label><br />
                <input type="text" name="courseNameLabel" onChange={this.onCourseNameChange} required={true} value={this.state.courseName} ref={this.nameRef} />

                <div>
                    <p>*You have to create the following labels in in RemoteConfig:</p>
                    <ul>
                        <li>{this.state.titleLabel} Will contains the title for the course.</li>
                    </ul>
                </div>

                <fieldset>
                    <legend>Day of the week</legend>
                    {
                        this.dayIndexMapping.map(entry => {
                            return  (
                                <CourseDayDetail key={entry.index}
                                    weekDayName={entry.day} index={entry.index} checkDayOfTheWeek={this.checkDayOfTheWeek}
                                    onDayChecked={this.onDayChecked} onTeacherSelected={this.onTeacherSelected}
                                    onThemeChanged={this.onThemeChanged} onTitleChanged={this.onTitleChanged}
                                    teacherDayOfTheWeek={this.teacherDayOfTheWeek} titleDayOfWeek={this.titleDayOfWeek}
                                    themeDayOfWeek={this.themeDayOfWeek} durationDayOfWeek={this.durationDayOfWeek}
                                    onDurationChanged={this.onDurationChanged}
                                    onCoverImageUrlChanged={this.onCoverImageUrlChanged} coverImageUrlDayOfWeek={this.coverImageUrlDayOfWeek}
                                    onCustomDescriptionChanged={this.onCustomDescriptionChanged} customDescriptionDayOfWeek={this.customDescriptionDayOfWeek}
                                />
                            );
                        })
                    }
                </fieldset>
                <br />

                <label htmlFor="timeOfDay">Time of the day</label><br />
                <input type="text" name="timeOfDay" required={true} value={this.state.timeOfTheDay} ref={this.inputRef} onChange={this.checkTime} />
                <p>*Must be in the 24hours clock. e.g. 14:00, 08:30 etc..</p>
                <label htmlFor="duration">Class Duration (in Minute)</label>
                <input type="text" name="duration" required={true} value={this.state.duration} onChange={this.setDuration} />

                <TextField
                    label="Description"
                    className="class-description"
                    multiline
                    value={this.state.description}
                    onChange={ e => this.setState({description: e.target.value})}
                    rows={4}
                    required={true}
                    variant="outlined"
                />
                <input type="submit" />
            </form>
        </div>)
    }

    private setDuration(event: React.ChangeEvent<HTMLInputElement>) {
        const currentValue = Number(event.currentTarget.value)
        this.setState({ duration: currentValue })
    }

    private onTeacherSelected(dayIndex: number) {
        return (doc: TeacherConfig) => {
            this.state.teacherDayMapping.forEach((n, i) => {
                if (n.dayIndex === dayIndex) {
                    n.teacherId = doc.uuid
                }
            })
            this.setState(this.state)
        }
    }

    private onTitleChanged(dayIndex: number) {
        return (event: React.ChangeEvent<HTMLInputElement>) => {
            this.state.teacherDayMapping.forEach((n, i) => {
                if (n.dayIndex === dayIndex) {
                    n.title = event.target.value;
                }
            });
            this.setState(this.state);
        }
    }

    private onThemeChanged(dayIndex: number) {
        return (event: React.ChangeEvent<HTMLInputElement>) => {
            this.state.teacherDayMapping.forEach((n, i) => {
                if (n.dayIndex === dayIndex) {
                    n.theme = event.target.value;
                }
            });
            this.setState(this.state);
        }
    }

    private onDurationChanged(dayIndex: number) {
        return (event: React.ChangeEvent<HTMLInputElement>) => {
            this.state.teacherDayMapping.forEach((n, i) => {
                if (n.dayIndex === dayIndex) {
                    n.duration = event.target.value ? parseInt(event.target.value, 10) : null;
                }
            });
            this.setState(this.state);
        }
    }

    private onCoverImageUrlChanged(dayIndex: number) {
        return (event: React.ChangeEvent<HTMLInputElement>) => {
            this.state.teacherDayMapping.forEach((n, i) => {
                if (n.dayIndex === dayIndex) {
                    n.coverImageUrl = event.target.value;
                }
            });
            this.setState(this.state);
        }
    }

    private onCustomDescriptionChanged(dayIndex: number) {
        return (event: React.ChangeEvent<HTMLTextAreaElement>) => {
            this.state.teacherDayMapping.forEach((n, i) => {
                if (n.dayIndex === dayIndex) {
                    n.customDescription = event.target.value;
                }
            });
            this.setState(this.state);
        }
    }

    private resetForm(_: any) {
        const newState = new CourseDetailState()
        newState.courseName = "";
        newState.timeOfTheDay = "";
        newState.selectedId = "";
        this.setState(newState)
    }
    private checkDayOfTheWeek(index: number): boolean {
        let res = false
        for (const value of this.state.teacherDayMapping) {
            res = (value.dayIndex === index)
            if (res) {
                break
            }
        }
        return res
    }

    private teacherDayOfTheWeek(index: number): string {
        let res = ""
        for (const value of this.state.teacherDayMapping) {
            if (value.dayIndex === index) {
                res = value.teacherId
            }
        }
        return res
    }

    private titleDayOfWeek(index: number) : string {
        let response = "";
        for (const value of this.state.teacherDayMapping) {
            if (value.dayIndex === index) {
                response = value.title || "";
                break;
            }
        }
        return response;
    }

    private themeDayOfWeek(index: number) : string {
        let response = "";
        for (const value of this.state.teacherDayMapping) {
            if (value.dayIndex === index) {
                response = value.theme || "";
                break;
            }
        }
        return response;
    }

    private durationDayOfWeek(index: number) : any {
        let response: any = "";
        for (const value of this.state.teacherDayMapping) {
            if (value.dayIndex === index) {
                response = value.duration || "";
                break;
            }
        }
        return response;
    }

    private coverImageUrlDayOfWeek(index: number) : string {
        let response = "";
        for (const value of this.state.teacherDayMapping) {
            if (value.dayIndex === index) {
                response = value.coverImageUrl || "";
                break;
            }
        }
        return response;
    }

    private customDescriptionDayOfWeek(index: number) : string {
        let response = "";
        for (const value of this.state.teacherDayMapping) {
            if (value.dayIndex === index) {
                response = value.customDescription || "";
                break;
            }
        }
        return response;
    }


    private onDayChecked(event: React.ChangeEvent<HTMLInputElement>) {
        const currentValue = Number(event.currentTarget.value)
        if (event.currentTarget.checked) {
            const obj = new TeacherDayMapping()
            obj.dayIndex = currentValue
            obj.teacherId = ""
            this.state.teacherDayMapping.push(obj)
        } else {
            this.state.teacherDayMapping.forEach((n, i) => {
                if (n.dayIndex === currentValue) {
                    this.state.teacherDayMapping.splice(i, 1)
                }
            })
        }
        this.setState(this.state)
    }

    private checkTime(event: React.ChangeEvent<HTMLInputElement>) {
        if (this.inputRef.current!.value.match('[0-9]{2}:[0-9]{2}') !== null) {
            this.inputRef.current!.setCustomValidity('')
        } else {
            this.inputRef.current!.setCustomValidity('Invalid time')
        }
        this.setState({ timeOfTheDay: event.target.value })
    }

    private onSubmit(event: React.FormEvent) {
        event.preventDefault();
        if (this.inputRef.current!.value.match('[0-9]{2}:[0-9]{2}') !== null) {
            this.inputRef.current!.setCustomValidity('')
        } else {
            this.inputRef.current!.setCustomValidity('Invalid time')
        }

        if (this.formRef.current!.checkValidity()) {
            const obj = new CourseConfig();
            obj.backgroundImgURL = this.state.backgroundImgURL;
            obj.descriptionLabel = this.state.descriptionLabel;
            obj.duration = this.state.duration;
            obj.description = this.state.description;
            obj.id = this.state.id;
            obj.timeOfTheDay = this.state.timeOfTheDay;
            obj.titleLabel = this.state.titleLabel;
            obj.teacherDayMapping = this.state.teacherDayMapping.map(value => {
                return Object.assign({}, value)
            });
            obj.timeOfTheDay = this.inputRef.current!.value;


            const courseRef = firebase.firestore().collection('config').doc("CoursesConfig").collection('courses')
            let docRef: Promise<any>;
            if (this.state.selectedId !== undefined && this.state.selectedId.length > 0) {
                docRef = courseRef.doc(this.state.selectedId).update(Object.assign({}, obj))
                    .then( _ => {
                        window.alert('Course updated successfully.');
                    });
            } else {
                docRef = courseRef.add(Object.assign({}, obj)).then( _ => {
                    window.alert('Course created successfully.');
                });
            }
            docRef.catch(err => {
                Sentry.captureException(err);
            })
        }
    }

    private onCourseNameChange(event: React.ChangeEvent<HTMLInputElement>) {
        const course = event.target.value.replace(" ", "_")
        console.log(course)
        const title = `session_${course}_title`.toLowerCase()
        const desc = `session_${course}_description`.toLowerCase()
        this.setState({
            courseName: course,
            descriptionLabel: desc,
            titleLabel: title
        })
    }

    private getClassIdentifier(titleLabel: string): string {
        const match = titleLabel.match('session_(.+)_[title|description|background]')
        if (match !== null && match.length > 1) {
            return match[1].replace(/_/g, ' ')
        }
        return titleLabel
    }

}

export default CourseDetail


// WEBPACK FOOTER //
// ./src/components/schedule/course-detail/CourseDetail.tsx